var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "travelDestinationsMapSuppliersFilterInputWrapper" },
    [
      _c("input", {
        staticClass: "travelDestinationsMapSuppliersFilterInput",
        attrs: {
          type: "text",
          placeholder: "Enter Property Name, Chain, Brand...",
        },
        domProps: { value: _vm.searchTerm },
        on: { input: _vm.onSearch },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }